// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck FIXME please remove the TS no check
/// <reference types="@types/google.maps" />
import domTypeGuards from '~/composables/domTypeGuards';
import type {FreelancersPerArea} from '~/openapi';
const {hasProperty} = domTypeGuards();

const MAP_COORDINATES = {
    fr: {lat: 46.5, lng: 2.37359},
};
const MAP_STYLE_OPTIONS = [
    {featureType: 'administrative', elementType: 'all', stylers: [{visibility: 'off'}]},
    {featureType: 'landscape', elementType: 'all', stylers: [{visibility: 'off'}]},
    {featureType: 'road', elementType: 'all', stylers: [{visibility: 'off'}]},
    {featureType: 'poi', elementType: 'all', stylers: [{visibility: 'off'}]},
    {featureType: 'water', elementType: 'all', stylers: [{visibility: 'off'}]},
];
const MAP_AREA_COLORS: Record<string, string> = {
    PERCENTILE_0_20: '#FFb9B7',
    PERCENTILE_20_40: '#FF7370',
    PERCENTILE_40_60: '#FC5757',
    PERCENTILE_60_80: '#D4524F',
    PERCENTILE_80_100: '#A63633',
};

type UseCountryMapParams = {
    country: string;
    area: string;
    lang: string;
    areas: FreelancersPerArea[];
};

export function countryMapController(params: UseCountryMapParams) {
    let infowindow: google.maps.InfoWindow;
    let map: google.maps.Map;
    let mapElement: HTMLElement | null;

    function removeDiacritics(s: string): string {
        const diacritics = [
            [/[\300-\306]/g, 'A'],
            [/[\340-\346]/g, 'a'],
            [/[\310-\313]/g, 'E'],
            [/[\350-\353]/g, 'e'],
            [/[\314-\317]/g, 'I'],
            [/[\354-\357]/g, 'i'],
            [/[\322-\330]/g, 'O'],
            [/[\362-\370]/g, 'o'],
            [/[\331-\334]/g, 'U'],
            [/[\371-\374]/g, 'u'],
            [/[\321]/g, 'N'],
            [/[\361]/g, 'n'],
            [/[\307]/g, 'C'],
            [/[\347]/g, 'c'],
        ] as [RegExp, string][];
        for (let i = 0; i < diacritics.length; i++) {
            s = s.replace(diacritics[i][0], diacritics[i][1]);
        }
        return s;
    }

    function getArea(name: string) {
        if (!name) return name;
        const normalizedName = removeDiacritics(name.toLowerCase()).replace(/-/g, ' ');
        return params.areas.find((a) => a.area === normalizedName);
    }

    function showRegionTooltip(e: any) {
        const name = e.feature.getProperty('nom');
        const area = getArea(name);
        const count = hasProperty(area, 'count') ? area.count : 0;
        const contentString = `<p class="ft-thin v-tac u-mb1">${name}</p><strong class="txt-huge">${count}</strong>`;
        hideRegionTooltip();
        infowindow = new google.maps.InfoWindow({content: contentString, position: e.latLng, disableAutoPan: true});
        infowindow.open(map);
    }

    function hideRegionTooltip() {
        if (infowindow) {
            infowindow.close();
        }
    }

    function setFreelancerDistributionInRegionStyles() {
        map.data.setStyle((feature) => {
            let fillColor = '#E0DED9';
            const name = feature.getProperty('nom') as string;
            const area = getArea(name);
            if (hasProperty(area, 'area')) {
                fillColor = MAP_AREA_COLORS[area.range] || fillColor;
            }
            return {fillColor, fillOpacity: 1, strokeColor: 'white', strokeOpacity: 1, strokeWeight: 1};
        });
    }

    function loadCountryMap(elementId: string) {
        window.initCountryMap = () => {
            const center = new google.maps.LatLng(46.5, 2.37359);
            mapElement = document.getElementById(elementId);
            map = new google.maps.Map(mapElement!, {
                center,
                zoom: 6,
                draggable: false,
                mapTypeControl: false,
                streetViewControl: false,
                disableDefaultUI: true,
                scrollwheel: false,
                mapTypeId: 'mystyle',
                backgroundColor: 'transparent',
            });
            map.mapTypes.set('mystyle', new google.maps.StyledMapType(MAP_STYLE_OPTIONS, {name: 'My Style'}));
            map.data.loadGeoJson(`https://cdn.malt.com/maps/${params.country}_${params.area}.geojson`);

            setFreelancerDistributionInRegionStyles();
            mapResize();
            map.data.addListener('mousemove', showRegionTooltip);
            map.data.addListener('mouseout', hideRegionTooltip);
        };

        const script = document.createElement('script');
        const baseUrl = 'https://maps.googleapis.com/maps/api/js';
        const urlParams = `?key=AIzaSyBFTHCOj6N3G50UYe3UcmQloB57i-aUlPM&libraries=places&loading=async&callback=initCountryMap&language=${params.lang}`;
        script.src = `${baseUrl}${urlParams}`;
        document.head.appendChild(script);
    }

    function destroyCountryMap() {
        hideRegionTooltip();
        if (map.data.removeListener) {
            map.data.removeListener('mousemove', showRegionTooltip);
            map.data.removeListener('mouseout', hideRegionTooltip);
            delete window.initCountryMap;
        }
    }

    function mapResize() {
        if (!map) return;
        const mapWidth = mapElement?.offsetWidth as number;
        const maxZoom = 6;
        const minWidth = 350;
        const maxWidth = 700;
        const maxDelta = maxWidth - minWidth;
        const ratio = 1 - (mapWidth - minWidth) / maxDelta;
        const coeff = 1.2;
        const zoom = maxZoom - ratio * coeff;
        map.setZoom(zoom);
    }

    return {
        loadCountryMap,
        destroyCountryMap,
        mapResize,
    };
}
